import { render, staticRenderFns } from "./InTheAssessment.vue?vue&type=template&id=f448536c&scoped=true&"
import script from "./InTheAssessment.vue?vue&type=script&lang=js&"
export * from "./InTheAssessment.vue?vue&type=script&lang=js&"
import style0 from "./InTheAssessment.vue?vue&type=style&index=0&id=f448536c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f448536c",
  null
  
)

export default component.exports